import { render, staticRenderFns } from "./RecentArticleView.vue?vue&type=template&id=8d606492"
import script from "./RecentArticleView.ts?vue&type=script&lang=ts&external"
export * from "./RecentArticleView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports